/**
 * The mock's icon sprite, ported verbatim. Symbol ids are prefixed `rsb-` so
 * they cannot collide with any other sprite on the site.
 */

const SYMBOLS: Array<[string, React.ReactNode]> = [
  ['upload', <path key='p' d='M12 16V3m-5 5 5-5 5 5M4 15v6h16v-6' />],
  ['arrow', <path key='p' d='M5 12h14m-6-6 6 6-6 6' />],
  ['download', <path key='p' d='M12 3v13m-5-5 5 5 5-5M4 16v5h16v-5' />],
  ['lock', <path key='p' d='M7 10V7a5 5 0 0 1 10 0v3M4 10h16v11H4zM12 14v3' />],
  [
    'search',
    <>
      <circle key='c' cx='10.5' cy='10.5' r='6.5' />
      <path key='p' d='m16 16 5 5' />
    </>,
  ],
  ['check', <path key='p' d='m5 12 4 4L19 6' />],
  ['file', <path key='p' d='M5 3h10l4 4v14H5zM14 3v5h5M8 12h8M8 16h6' />],
  ['edit', <path key='p' d='m14 5 5 5M4 20l1-6L16 3l5 5-11 11-6 1z' />],
  ['expand', <path key='p' d='M9 3H3v6m12-6h6v6M3 15v6h6m12-6v6h-6' />],
  ['close', <path key='p' d='m6 6 12 12M6 18 18 6' />],
  ['warning', <path key='p' d='m12 3 10 18H2L12 3zM12 9v5m0 3v1' />],
  ['chat', <path key='p' d='M3 4h18v13H8l-5 4V4zM7 8h10M7 12h6' />],
  ['plus', <path key='p' d='M12 4v16M4 12h16' />],
  [
    'trash',
    <path key='p' d='M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7' />,
  ],
  ['out', <path key='p' d='M7 17 19 5M8 5h11v11M5 9v11h11' />],
]

export type IconName =
  | 'upload'
  | 'arrow'
  | 'download'
  | 'lock'
  | 'search'
  | 'check'
  | 'file'
  | 'edit'
  | 'expand'
  | 'close'
  | 'warning'
  | 'chat'
  | 'plus'
  | 'trash'
  | 'out'

export function IconSprite() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={{
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
      }}
      aria-hidden='true'
    >
      <defs>
        {SYMBOLS.map(([name, children]) => (
          <symbol key={name} id={`rsb-i-${name}`} viewBox='0 0 24 24'>
            {children}
          </symbol>
        ))}
      </defs>
    </svg>
  )
}

export function Icon({
  name,
  className = '',
  style,
}: {
  name: IconName
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <svg
      className={`rsb-icon ${className}`.trim()}
      style={style}
      aria-hidden='true'
    >
      <use href={`#rsb-i-${name}`} />
    </svg>
  )
}
